module.exports = __webpack_public_path__ + "Roboto-MediumItalic.woff?5df7f0532c1c39e04011b2ab0be1fe3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/MediumItalic/Roboto-MediumItalic.woff?v=2.137
// module id = 680
// module chunks = 7